// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

// ** Axios Imports
import axios from 'axios'

export const getAllDataPlaylistsClient = createAsyncThunk('appUsers/getAllDataPlaylistsClient', async id => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/client/playlists/all',  { params: { id} })
  return response.data
})

export const getDataPlaylistsClient = createAsyncThunk('appUsers/getDataPlaylistsClient', async params => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/client/playlists/data', {params})
  return {
    params,
    data: response.data.data,
    totalPages: response.data.total
  }
})

export const getUser = createAsyncThunk('appUsers/getUser', async id => {
  const response = await axios.get('https://apiv4dev2.opentlv.com/api/v3/users/user', { params: { id} })
  console.log(response.data)
  return response.data
})

export const addUser = createAsyncThunk('appUsers/addUser', async (user, { dispatch, getState }) => {
  await axios.post('/apps/users/add-user', user)
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return user
})

export const deleteUser = createAsyncThunk('appUsers/deleteUser', async (id, { dispatch, getState }) => {
  await axios.delete('/apps/users/delete', { id })
  await dispatch(getData(getState().users.params))
  await dispatch(getAllData())
  return id
})
export const addPlaylist = createAsyncThunk('appUsers/addPlaylist', async (playlist, { dispatch, getState }) => {
  //playlist.client_id = getState().sitesClient.params.id
  //console.log(getState().sitesClient)


  await axios.post('https://apiv4dev2.opentlv.com/api/v3/client/addplaylist', playlist)

  //await dispatch(getAllDataSitesClient(getState().sitesClient.params.id))
  await dispatch(getDataPlaylistsClient(getState().playlistsClient.params))
  return playlist
})

export const deletePlaylist = createAsyncThunk('appUsers/deletePlaylist', async (id, { dispatch, getState }) => {
  console.log("getState()")
  console.log(id)

  await axios.delete('https://apiv4dev2.opentlv.com/api/v3/client/playlist/delete', {params: {id}})
//  await dispatch(getData(getState().users.params))
    await dispatch(getDataPlaylistsClient(getState().playlistsClient.params))

  return id
})
export const appClientsSlice = createSlice({
  name: 'appUsers',
  initialState: {
    data: [],
    total: 1,
    params: {},
    allData: [],
    selectedUser: null
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(getAllDataPlaylistsClient.fulfilled, (state, action) => {
        state.allData = action.payload
      })
      .addCase(getDataPlaylistsClient.fulfilled, (state, action) => {
        state.data = action.payload.data
        state.params = action.payload.params
        state.total = action.payload.totalPages
      })
      .addCase(getUser.fulfilled, (state, action) => {
        state.selectedUser = action.payload
      })
  }
})

export default appClientsSlice.reducer
